import { render, staticRenderFns } from "./UpdateProjectForm.vue?vue&type=template&id=1d5ac6ea&"
import script from "./UpdateProjectForm.vue?vue&type=script&lang=js&"
export * from "./UpdateProjectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports